import { valueForKeyPath } from 'key.path'
// ///////////////////////////////////////////////////////
import { value, filterEmpty, isNumber } from './utils'

// ///////////////////////////////////////////////////////
const defaultSizes = [0, 32, 64, 92, 124, 156]

// ///////////////////////////////////////////////////////
export const composeBoxModelSizes = props => {
  const sizes = valueForKeyPath('theme.sizes', props) || defaultSizes
  return filterEmpty({
    width: isNumber(props.w) ? value(sizes)(props.w) : null,
    height: isNumber(props.h) ? value(sizes)(props.h) : null
  })
}
